import { Injectable, inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { ProfileService } from '../shared/services/app/profile.service';
import { SessionService } from '../shared/services/app/session.service';
import { ROUTE_AUTH, ROUTE_LOGOUT } from '../shared/consts/routes.const';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  private profileService = inject(ProfileService);
  private session = inject(SessionService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.isAccessAllowed(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state);
  }

  isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let permission = false;
      if (this.profileService.isLoggedIn()) {
        const requiredRoles: string[] = route.data['roles'];
        if (!requiredRoles || requiredRoles.length === 0) {
          permission = true;
        } else {
          permission = requiredRoles.some((role) => this.profileService.getRoles().indexOf(role) > -1);
        }
      }

      if (!permission) {
        this.router.navigate([`/${ROUTE_AUTH}/${ROUTE_LOGOUT}`]);
        reject(false);
      }

      resolve(permission);
    });
  }
}
